
// This is an auto generated file - do not edit!
// Swagger path: /api/AmlRisk/duplicates

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    MatchedDuplicateQueryResult
} from '@wdx/clmi/clmi-swagger-gen';
import { PaginationOptions } from '@wdx/shared/infrastructure/api-service';

@Injectable({ providedIn: 'root' })
export class AmlriskDuplicatesApiService extends BaseApiService {
    
    get(options = {}, paginationOptions?: PaginationOptions): Observable<MatchedDuplicateQueryResult> {
        return this._get<MatchedDuplicateQueryResult>(
            `/AmlRisk/duplicates`,
            options,
            paginationOptions
        );
    }

    patch(body: any, options = {}): Observable<any> {
        return this._patch<any, any>(
            `/AmlRisk/duplicates`,
            body,
            options
        );
    }
}
